import type { ReactNode } from "react";
import { Stack } from "@volca/ui/components/ui/stack";
import { AppBreadcrumbs } from "@/app-shell/app-breadcrumbs";
import { MAIN_CONTENT_ID } from "@/app-shell/skip-link";
import { WorkspaceHeader } from "./workspace-header";

export const WorkspaceLayout = ({
  children,
  onImpersonate,
}: {
  children: ReactNode;
  onImpersonate?: () => void;
}) => (
  <Stack className="min-h-0 min-w-0 flex-1" align="stretch">
    <WorkspaceHeader onImpersonate={onImpersonate} />
    <AppBreadcrumbs />
    <Stack
      render={<main id={MAIN_CONTENT_ID} tabIndex={-1} />}
      className="min-h-0 flex-1 [scrollbar-gutter:stable] overflow-y-auto outline-hidden [container:page/size]"
      align="stretch"
    >
      {children}
    </Stack>
  </Stack>
);
